import React, { useState } from "react";

// import UserContext from "./context/Context";

let gstDetails = [];

export const PurchaseGstCalculation = (Party, product, Context, Charges) => {
  console.log("part", Party);

  let IgstTotal = 0;
  let CgstTotal = 0;
  let SgstTotal = 0;
  let Amount = 0;
  let GrandTotal = 0;
  let RoundOff = 0;
  let Discount = 0;
  let DiscountPercentage = 0;
  let OtherGSTCharges = 0;

  Charges = Number(Charges || 0);

  if (!!Party?.category?.discount) {
    DiscountPercentage = (100 + Party?.category?.discount) / 100;
  } else {
    DiscountPercentage = (100 + (Party?.category?.discount || 0)) / 100;
  }

  function customRound(num) {
    let decimalPart = num - Math.floor(num);
    if (decimalPart > 0.49) {
      return Math.ceil(num);
    } else {
      return Math.floor(num);
    }
  }

  let IgstTaxType = false;

  const companyStateCode = String(
    Context?.CompanyDetails?.gstNo ||
      Context?.CompanyDetails?.GSTIN ||
      Context?.CompanyDetails?.gstNumber ||
      "",
  )
    .trim()
    .slice(0, 2);

  const companyStateName = String(
    Context?.CompanyDetails?.State || Context?.CompanyDetails?.state || "",
  )
    .trim()
    .toLowerCase();

  const userdata = JSON.parse(localStorage.getItem("userData") || "{}");
  const findParty = userdata?.rolename?.roleName === "Customer";

  const explicitRegionType = String(
    Party?.regionType || Party?.RegionType || Party?.partyRegion || "",
  )
    .trim()
    .toLowerCase();

  const partyStateCode = String(
    (findParty ? userdata?.gstNumber : Party?.gstNumber) ||
      Party?.gstNo ||
      Party?.GSTIN ||
      "",
  )
    .trim()
    .slice(0, 2);

  const partyStateName = String(
    Party?.State || Party?.state || Party?.billingState || "",
  )
    .trim()
    .toLowerCase();

  const isLocalParty = explicitRegionType
    ? explicitRegionType === "local"
    : partyStateCode
      ? companyStateCode &&
        partyStateCode &&
        String(companyStateCode) === String(partyStateCode)
      : companyStateName &&
        partyStateName &&
        String(companyStateName) === String(partyStateName);

  IgstTaxType = !isLocalParty;

  (product || [])?.forEach((ele) => {
    if (typeof ele?.gstPercentage === "number") return;

    if (String(ele?.gstPercentage || "").includes("+")) {
      ele.gstPercentage = String(ele.gstPercentage)
        .split("+")
        .map((x) => Number(x) || 0)
        .reduce((a, b) => a + b, 0);
    } else {
      ele.gstPercentage = Number(
        ele?.gstPercentage || ele?.productData?.GSTRate || 0,
      );
    }
  });

  let maxGst =
    (product || []).length > 0
      ? (product || []).reduce((prev, current) =>
          Number(prev?.gstPercentage || 0) > Number(current?.gstPercentage || 0)
            ? prev
            : current,
        )
      : { gstPercentage: 0 };

  maxGst.gstPercentage = Number(maxGst?.gstPercentage || 0);

  if (Charges) {
    OtherGSTCharges = Number(
      ((Charges * Number(maxGst?.gstPercentage || 0)) / 100).toFixed(2),
    );
  }

  gstDetails = (product || [])?.map((ele) => {
    const wholeGst = Number(
      ele?.gstPercentage || ele?.productData?.GSTRate || 0,
    );
    const halfGst = wholeGst / 2;

    const costPrice = Number(
      ele?.basicPrice !== undefined &&
        ele?.basicPrice !== null &&
        ele?.basicPrice !== ""
        ? ele?.basicPrice
        : ele?.price || 0,
    );

    const qty = Number(ele?.qty || 0);
    const taxable = Number((costPrice * qty).toFixed(2));
    const grandTotal = Number(((taxable * (100 + wholeGst)) / 100).toFixed(2));

    const Cp_without_Discount = Number(
      (costPrice / ((100 + Number(wholeGst || 0)) / 100)).toFixed(2),
    );

    if (IgstTaxType) {
      return {
        unitPriceAfterDiscount: Number(costPrice.toFixed(2)),
        gstPercentage: wholeGst,
        sgstRate: 0,
        cgstRate: 0,
        igstRate: Number(((taxable * wholeGst) / 100).toFixed(2)),
        costPrice: costPrice,
        grandTotal: grandTotal,
        taxableAmount: taxable,
        hsn: ele?.HSN_Code || ele?.productData?.HSN_Code,
        taxable: taxable,
        withoutTaxablePrice: `${taxable}`,
        discountPercentage: Party?.category?.discount || 0,
        withDiscountAmount: grandTotal,
        withoutDiscountAmount: Number(
          ((Cp_without_Discount * qty * (100 + wholeGst)) / 100).toFixed(2),
        ),
        totalTaxAmount: Number(((taxable * wholeGst) / 100).toFixed(2)),
        centralTax: [],
        stateTax: [],
        igstTax: [
          {
            rate: wholeGst,
            amount: Number(((taxable * wholeGst) / 100).toFixed(2)),
          },
        ],
      };
    }

    return {
      gstPercentage: `${halfGst}+${halfGst}`,
      sgstRate: Number(((taxable * halfGst) / 100).toFixed(2)),
      cgstRate: Number(((taxable * halfGst) / 100).toFixed(2)),
      igstRate: 0,
      totalRate: Number(((taxable * wholeGst) / 100).toFixed(2)),
      costPrice: costPrice,
      hsn: ele?.HSN_Code || ele?.productData?.HSN_Code,
      withoutTaxablePrice: `${taxable}`,
      taxable: taxable,
      discountPercentage: Party?.category?.discount || 0,
      withDiscountAmount: grandTotal,
      taxableValue: grandTotal,
      taxableAmount: taxable,
      unitPriceAfterDiscount: Number(costPrice.toFixed(2)),
      withoutDiscountAmount: Number(
        ((Cp_without_Discount * qty * (100 + wholeGst)) / 100).toFixed(2),
      ),
      centralTax: [
        {
          rate: halfGst,
          amount: Number(((taxable * halfGst) / 100).toFixed(2)),
        },
      ],
      stateTax: [
        {
          rate: halfGst,
          amount: Number(((taxable * halfGst) / 100).toFixed(2)),
        },
      ],
      igstTax: [],
      grandTotal: grandTotal,
    };
  });

  let T = gstDetails?.map((ele) => Number(ele?.taxable || 0)) || [];
  Amount = T.length ? T.reduce((a, b) => a + b, 0) : 0;

  if (IgstTaxType) {
    let x =
      gstDetails?.map((ele) => Number(ele?.igstTax?.[0]?.amount || 0)) || [];
    IgstTotal = x.length ? x.reduce((a, b) => a + b, 0) : 0;
  } else {
    let C =
      gstDetails?.map((ele) => Number(ele?.centralTax?.[0]?.amount || 0)) || [];
    CgstTotal = C.length ? C.reduce((a, b) => a + b, 0) : 0;

    let S =
      gstDetails?.map((ele) => Number(ele?.stateTax?.[0]?.amount || 0)) || [];
    SgstTotal = S.length ? S.reduce((a, b) => a + b, 0) : 0;
  }

  GrandTotal = Number(
    (
      Amount +
      SgstTotal +
      CgstTotal +
      IgstTotal +
      Charges +
      OtherGSTCharges
    ).toFixed(2),
  );

  RoundOff = customRound(GrandTotal);

  let Tax = {
    maxGst: Number(maxGst?.gstPercentage || 0),
    OtherGSTCharges: Number(OtherGSTCharges || 0),
    TotalOtherCharges: Number((Charges + OtherGSTCharges).toFixed(2)),
    Charges: Number(Charges || 0),
    IgstTaxType: IgstTaxType,
    RoundOff: Number((RoundOff - GrandTotal).toFixed(2)),
    GrandTotal: Number(RoundOff?.toFixed(2)),
    Amount: Number(Amount?.toFixed(2)),
    IgstTotal: IgstTaxType
      ? Number((IgstTotal + OtherGSTCharges).toFixed(2))
      : Number(IgstTotal.toFixed(2)),
    CgstTotal: IgstTaxType
      ? Number(CgstTotal.toFixed(2))
      : Number((CgstTotal + OtherGSTCharges / 2).toFixed(2)),
    SgstTotal: IgstTaxType
      ? Number(SgstTotal.toFixed(2))
      : Number((SgstTotal + OtherGSTCharges / 2).toFixed(2)),
  };

  return { gstDetails, Tax };
};
